module.exports = __webpack_public_path__ + "media/reskin-images/icon--smartphone-4c7cbca4.svg";